import { oc } from '@orpc/contract';
import { getValuationInputSchema, valuationSnapshotDetailSchema } from '../schemas/valuations.schemas.js';
/** The whole stored document — inputs, outputs, trace, cost resolution and both version ids (PP AC14). */
export const getValuationContract = oc
    .route({
    method: 'GET',
    path: '/valuations/{valuationId}',
    tags: ['Valuations'],
    summary: 'Read one saved snapshot',
})
    .input(getValuationInputSchema)
    .output(valuationSnapshotDetailSchema);
//# sourceMappingURL=get-valuation.contract.js.map